/* eslint-disable  @typescript-eslint/no-explicit-any */
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
} from "@mui/material";
import { TextValidator } from "react-material-ui-form-validator";
import { Vocabulary } from "../../Utils/Vocabulary";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FgoFormData } from "./FgoMainPage";
import { useEffect, useState } from "react";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";
import dayjs from "dayjs";

type FgoGeneralFormProps = {
  formData: FgoFormData;
  handleChange: (field: string, value: any) => void;
};

export default function FgoGeneralForm(props: FgoGeneralFormProps) {
  const { formData, handleChange } = props;

  const [fgoData, setFgoData] = useState({
    invoiceTypes: [],
    currencyTypes: [],
  });

  useEffect(() => {
    const getFgoData = async () => {
      const invoiceData = (await getData(`${urlEnum.fgo}/tipfactura`)).data
        .List;
      const currencyData = (await getData(`${urlEnum.fgo}/valuta`)).data.List;
      setFgoData({
        invoiceTypes: invoiceData,
        currencyTypes: currencyData,
      });
    };
    getFgoData();
  }, []);

  return (
    <Grid container spacing={2} style={{ marginTop: 10 }}>
      <Grid item xs={12} sm={6}>
        <TextValidator
          size="small"
          name="text"
          label={Vocabulary.text}
          fullWidth
          variant="outlined"
          value={formData.Text}
          onChange={(e: any) => handleChange("Text", e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextValidator
          size="small"
          name="explicatii"
          label={Vocabulary.explication}
          fullWidth
          variant="outlined"
          value={formData.Explicatii}
          onChange={(e: any) => handleChange("Explicatii", e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          size="small"
          id="valuta"
          freeSolo={true}
          options={fgoData.currencyTypes}
          value={
            fgoData.currencyTypes.find(
              (opt: any) => opt.Nume === formData.Valuta
            ) || null
          }
          getOptionLabel={(option: any) => option.Nume}
          isOptionEqualToValue={(option: any, value: any) =>
            option.Nume === value.Nume
          }
          onChange={(event: any, value: any) => {
            handleChange("Valuta", value?.Nume || "");
          }}
          renderInput={(params: any) => (
            <TextValidator
              {...params}
              fullWidth
              label={Vocabulary.currency}
              value={formData.Valuta}
              variant="outlined"
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
            />
          )}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Autocomplete
          size="small"
          id="tipFactura"
          freeSolo={true}
          options={fgoData.invoiceTypes}
          value={
            fgoData.invoiceTypes.find(
              (opt: any) => opt.Nume === formData.TipFactura
            ) || null
          }
          getOptionLabel={(option: any) => option.Nume}
          isOptionEqualToValue={(option: any, value: any) =>
            option.Nume === value.Nume
          }
          onChange={(event: any, value: any) => {
            handleChange("TipFactura", value?.Nume || "");
          }}
          renderInput={(params: any) => (
            <TextValidator
              {...params}
              fullWidth
              label={Vocabulary.invoiceType}
              value={formData.TipFactura}
              variant="outlined"
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
            />
          )}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker"]}>
            <DatePicker
              label={Vocabulary.issueDate}
              value={formData.DataEmitere ? dayjs(formData.DataEmitere) : null}
              onChange={(newValue) => {
                handleChange("DataEmitere", newValue);
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                },
              }}
            />
          </DemoContainer>
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12} sm={6}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker"]}>
            <DatePicker
              label={Vocabulary.dueDate}
              value={
                formData.DataScadenta ? dayjs(formData.DataScadenta) : null
              }
              onChange={(newValue) => {
                handleChange("DataScadenta", newValue);
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                },
              }}
            />
          </DemoContainer>
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextValidator
          size="small"
          name="numar"
          label={Vocabulary.number}
          fullWidth
          variant="outlined"
          value={formData.Numar}
          onChange={(e: any) => handleChange("Numar", e.target.value)}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextValidator
          size="small"
          name="serie"
          label={Vocabulary.serial}
          fullWidth
          variant="outlined"
          value={formData.Serie}
          validators={["required"]}
          errorMessages={[Vocabulary.requiredField]}
          onChange={(e: any) => handleChange("Serie", e.target.value)}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextValidator
          size="small"
          name="platformaUrl"
          label={Vocabulary.externId}
          fullWidth
          variant="outlined"
          value={formData.IdExtern}
          onChange={(e: any) => handleChange("IdExtern", e.target.value)}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormGroup>
          <FormControlLabel
            onChange={(event) => {
              console.log(event.target);
              handleChange("TvaLaIncasare", !formData.TvaLaIncasare);
            }}
            checked={formData.TvaLaIncasare}
            control={<Checkbox />}
            label={Vocabulary.vatAtCharge}
          />
        </FormGroup>
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormGroup>
          <FormControlLabel
            onChange={(event) => {
              console.log(event.target);
              handleChange("VerificareDuplicat", !formData.VerificareDuplicat);
            }}
            checked={formData.VerificareDuplicat}
            control={<Checkbox />}
            label={Vocabulary.checkDuplicate}
          />
        </FormGroup>
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormGroup>
          <FormControlLabel
            onChange={(event) => {
              console.log(event.target);
              handleChange("ValideazaCodUnicRo", !formData.ValideazaCodUnicRo);
            }}
            checked={formData.ValideazaCodUnicRo}
            control={<Checkbox />}
            label={Vocabulary.validateRoCode}
          />
        </FormGroup>
      </Grid>
    </Grid>
  );
}
